import { z } from "zod";

export const RequestDetailInputSchema = z.object({
    requestId: z.string(),
    shouldBeNotified: z.boolean().nullish(),
    userName: z.string().nullish(),
});

export type RequestDetailInput = z.infer<typeof RequestDetailInputSchema>;
